/* import { CopyOutlined } from '@ant-design/icons'; */
/* import { Button, message } from 'antd'; */
import React from "react";
import {
  EmailIcon,
  EmailShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from "react-share";
import style from "./style.module.css";

interface monInterface {
  prefix: string;
  codeAcces: string;
  createdClassName?: string;
  userLastname: string;
  userFirstname: string;
}
const index: React.FC<monInterface> = (props) => {

  const title = `Le professeur ${props.userLastname} ${props.userFirstname} t’invite à rejoindre sa classe « ${props.createdClassName} » sur la plateforme Mon Ami Albert.\nTu peux y accéder en insérant le code d’accès suivant « ${props.codeAcces} » sur la page ci-après : `;
  const body = `Le professeur ${props.userLastname} ${props.userFirstname} t’invite à rejoindre sa classe « ${props.createdClassName} » sur la plateforme Mon Ami Albert.\nTu peux y accéder en insérant le code d’accès suivant « ${props.codeAcces} » sur la page ci-après : https://monamialbert.com/eleve/mes-classes\nOu directement en cliquant sur ce lien : https://monamialbert.com/eleve/mes-classes?classCode=${props.codeAcces}`;
  const url = `https://monamialbert.com/eleve/mes-classes?classCode=${props.codeAcces}`;
  const subject = `Rejoins la classe « ${props.createdClassName} » du prof « ${props.userLastname + " " + props?.userFirstname} » sur Mon Ami Albert!`;

  return (
    <div className={style.flexGap}>
      <div>
        {" "}
        <WhatsappShareButton title={title} url={url}>
          <WhatsappIcon size={32} round={true} />
        </WhatsappShareButton>
      </div>
      <div>
        {" "}
        <TwitterShareButton title={title} url={url}>
          <TwitterIcon size={32} round={true} />
        </TwitterShareButton>
      </div>{" "}
      <div>
        {" "}
        <EmailShareButton title={title} url={url} subject={subject} body={body}>
          <EmailIcon size={32} round={true} />
        </EmailShareButton>
      </div>
    </div>
  );
};

export default index;
